/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".user-profile-modal[_ngcontent-%COMP%]   .sections[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:40vw}.user-profile-modal[_ngcontent-%COMP%]   md-dialog-actions[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/modals/user-profile-modal/user-profile-modal.component.scss.shim.ngstyle.js.pre-build-optimizer.js